<script>
  import { useUrlParams } from "@stores/urlStore.js";
  import { filtersConfigStore } from "@stores/damFiltersConfigStores.js";
  import FilterModal from "./FilterModal.svelte";
  import { Button } from "paxray-components-svelte";

  import { damfilters } from "lib/stores.js";
  import Modal from "lib/components/Modal.svelte";
  import { fly } from "svelte/transition";
  import { uiFeatureStore } from "@stores/uiFeatureStore.js";
  import { MINUS_ICON, PLUS_ICON, RESET_ICON } from '@utils/icons.js';

  const urlParams = useUrlParams();
  const { getFilterByCurrentView } = filtersConfigStore;

  export let allFiltersDisabled = false;
  export let hideProcessFlow = false;

  let modalOpen = false;
  let modalHistoryOpen = false;
  let filterid = -1;
  let filterHistory = getFilterHistory();
  let filterOpen = false;
  let disabledFilters = 0;

  $: ({ idproject } = $urlParams);
  $: if (idproject && !$damfilters[idproject]) $damfilters[idproject] = [];
  $: ({
    views,
    filterDefinitions,
    filterColumnDefinitions,
    filterAllowedOperators,
    filterOperators,
    currentView,
    tab,
    storeLoaded,
  } = $filtersConfigStore);

  let filtersByView = {};
  $: {
    if (storeLoaded) {
      filtersByView = getFilterByCurrentView(
        views,
        filterDefinitions,
        filterColumnDefinitions,
        filterAllowedOperators,
        filterOperators,
        currentView,
        tab,
      );
    }
  }

  $: filters = filtersByView;

  $: filterLength = ($damfilters[idproject] || []).length;
  $: headerFilterLimit = filterLength > 4 ? 3 : 4;
  $: visibleFilters = ($damfilters[idproject] || []).slice(0, headerFilterLimit);
  $: hasMoreFilters = filterLength > visibleFilters.length;

  $: {
    $damfilters[idproject];
    filterHistory = getFilterHistory();
  }

  $: if (
    (idproject && $damfilters[idproject] && storeLoaded && currentView) ||
    (storeLoaded && tab)
  ) {
    disabledFilters = getDisabledFilters(currentView);
  }

  function isApplicable(filter) {
    if (!filter) return false;
    if (allFiltersDisabled) return false;
    if (currentView === "Workloads" && tab === "Users" && filter.col === "team") {
      return false;
    }
    const filtersView = filtersByView;
    const filterTab = filtersView.filter((filterView) => {
      return (
        filterView.type === filter.type && filterView.title === filter.title
      );
    });
    if (filterTab.length === 0) return false;
    const result = filterTab.some((filterView) => {
      if (filterView.filterDetails.length === 0) return true;

      return filterView.filterDetails.some((filterDetail) => {
        const colMatch =
          filterDetail.column === filter.col ||
          filterDetail.columns === filter.col ||
          (Array.isArray(filterDetail.columns) &&
            Array.isArray(filter.col) &&
            arraysEqual(filter.col, filterDetail.columns));

        const datatypeMatch =
          !filterDetail.datatype ||
          (Array.isArray(filterDetail.datatype)
            ? filterDetail.datatype.includes(filter.datatype)
            : filterDetail.datatype === filter.datatype);

        return colMatch && datatypeMatch;
      });
    });
    return result;
  }

  function arraysEqual(a, b) {
    if (!Array.isArray(a) || !Array.isArray(b)) return false;
    if (a.length !== b.length) return false;
    const sortedA = [...a].sort();
    const sortedB = [...b].sort();
    return sortedA.every((value, index) => value === sortedB[index]);
  }

  function getDisabledFilters(currentView) {
    const activeFilters = $damfilters[idproject] || [];
    if (!currentView || !storeLoaded || activeFilters.length === 0) return 0;

    return activeFilters.filter((filter) => !isApplicable(filter))
      .length;
  }

  function toggleFilterbar() {
    filterOpen = !filterOpen;
  }

  function getFilterHistory() {
    const filterHistory = localStorage.getItem("filterHistory");
    if (filterHistory) {
      return JSON.parse(filterHistory);
    }
    return [];
  }

  function setHistoryFilter(filter) {
    const historyFilter = localStorage.getItem("filterHistory");
    if (historyFilter) {
      const filterHistory = JSON.parse(historyFilter);
      filterHistory.unshift(filter);
      if (filterHistory.length > 5) {
        filterHistory.pop();
      }
      localStorage.setItem("filterHistory", JSON.stringify(filterHistory));
    } else {
      localStorage.setItem("filterHistory", JSON.stringify([filter]));
    }
    filterid = -1;
  }

  function saveFilter(filterCreate) {
    const filterid = $damfilters[idproject].length;
    $damfilters[idproject][filterid] = filterCreate;
    modalOpen = false;
    modalHistoryOpen = false;
    setHistoryFilter(filterCreate);
    filterHistory = getFilterHistory();
  }

  function removeFilter(id) {
    $damfilters[idproject].splice(id, 1);
    $damfilters = $damfilters;
  }

  function showAllFilters() {
    filterOpen = !filterOpen;
  }

  function getFilterField(filter) {
    if (filter.col === "applicationname") return "App/Website";
    const column = getFilterColumn(filter);
    return (
      column?.title ||
      (Object.keys(filterColumnDefinitions || {}).length === 0 ? "" : "Filter")
    );
  }

  function getFilterSelection(filter) {
    const column = getFilterColumn(filter);
    if (!column) return "";
    const values = Array.isArray(filter.value)
      ? filter.value
      : filter.value !== undefined && filter.value !== null
        ? [filter.value]
        : filter.steps || [];
    const translatedValues = values.map((value) => {
      const configuredValue = column?.values?.find((option) =>
        typeof option === "object"
          ? [option.id, option.key, option.value, option.title].some((key) => String(key) === String(value))
          : String(option) === String(value),
      );
      if (typeof configuredValue === "object") {
        return configuredValue.title || configuredValue.value || configuredValue.label || value;
      }
      return configuredValue ?? value;
    });
    return translatedValues.join(", ");
  }

  function getFilterColumn(filter) {
    return (
      filterColumnDefinitions[filter.col] ||
      Object.values(filterColumnDefinitions).find((column) =>
        column.columns && column.columns.includes(filter.col) && filter.datatype === column.datatype,
      )
    );
  }

  function getFilterComparison(filter) {
    return filterOperators[filter.comparison]?.title || filter.comparison || "";
  }
</script>

{#if $uiFeatureStore.processExplorer.filters}
<div class:has-filters={filterLength > 0} class="header_filter_content">
  <div class="active_filters" aria-label="Active filters">
    {#each visibleFilters as filter, id}
      <div class="active_filter" title={`${getFilterField(filter)} ${getFilterComparison(filter)} "${getFilterSelection(filter)}"`}>
        <button type="button" class="active_filter_text" on:click={() => { filterid = id; modalOpen = true; }}>
          <span class="active_filter_type">{getFilterField(filter)} {getFilterComparison(filter)}</span>
          <span class="active_filter_attribute">{getFilterSelection(filter).replace(/^"|"$/g, "")}</span>
        </button>
        <button type="button" class="remove_active_filter" aria-label={`Remove ${filter.name || "filter"}`} on:click={() => removeFilter(id)}>×</button>
      </div>
    {/each}
    {#if hasMoreFilters}
      <button type="button" class="show_all_filters" on:click={showAllFilters} title="Show all filters">
        <img src="/img/assistant/icons/more.svg" alt="Show all filters" />
      </button>
    {/if}
  </div>
  <div class="header_filter_button">
    <button type="button" class="filter_trigger" on:click={toggleFilterbar} title="Filters" aria-label="Open filters">
      <img src="/img/assistant/icons/filter_alt_filled.svg" alt="" aria-hidden="true" />
      {#if filterLength}
        <span class="filter_status">
          {disabledFilters > 0 ? `${filterLength - disabledFilters}/` : ""}{filterLength}
        </span>
      {/if}
    </button>
  </div>
</div>

{#if filterOpen}
  <div transition:fly={{ x: 20 }} class="filter_wrapper">
    <div class="filter_actions filter_action_row">
      <Button
        icon={PLUS_ICON}
        iconLeft={true}
        kind="secondary"
        text="Add Filter"
        on:click={() => {
          filterid = $damfilters[idproject].length;
          modalOpen = true;
        }}
      />
      <!-- @Adrian dieser Button hatte in der Repo, die ich gefunden habe, keine Funktion (bzw. ist die gleiche, wie "Add Filter") -->
      <Button
        icon={RESET_ICON}
        kind="secondary"
        iconLeft={true}
        text="Delete Filters"
        on:click={() => {
          $damfilters[idproject] = [];
          $damfilters = $damfilters;
        }}
      />
    </div>
    <div class="filter_container">
      {#key `${currentView}-${tab}`}
        {#each $damfilters[idproject] as filter, id}
          <div class={`filter ${!isApplicable(filter) ? "disable" : ""}`}>
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <span
              on:click={() => {
                if (!isApplicable(filter)) return;
                filterid = id;
                modalOpen = true;
              }}>{filter.name}</span
            >
            <Button
              kind="secondary"
              icon={MINUS_ICON}
              on:click={() => {
                $damfilters[idproject].splice(id, 1);
                $damfilters = $damfilters;
              }}
            />
          </div>
        {/each}
      {/key}
    </div>
    <!--
    <div class="filter_actions">
      <Button
        kind="secondary"
        text="Filter History"
        on:click={() => (modalHistoryOpen = !modalHistoryOpen)}
      />
    </div>
    -->
  </div>
{/if}

<FilterModal
  bind:modalOpen
  bind:filterid
  {idproject}
  {filterLength}
  {hideProcessFlow}
  {setHistoryFilter}
/>

<Modal
  class="history-modal"
  modalHeading="Filter History"
  bind:open={modalHistoryOpen}
  hideFooter
  autowidth
  on:close={() => (modalHistoryOpen = false)}
>
  <div class="button_history_wrapper">
    {#each filterHistory as filter}
      <Button
        text={filter.name || "Unnamed Flow Filter"}
        kind="secondary"
        on:click={() => saveFilter(filter)}
      />
    {/each}
  </div>
</Modal>

{/if}

<style>
  .filter_wrapper {
    position: fixed;
    right: 0;
    top: var(--app-header-height);
    bottom: 0;
    z-index: 20;
    width: min(22rem, calc(100vw - var(--app-side-nav-width)));
    min-width: 0;
    background-color: var(--pax-white);
    color: var(--pax-black);
    padding: 1rem;
    box-sizing: border-box;
    border-left: 1px solid #d9d9d9;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .header_filter_button {
    position: relative;
    display: flex;
    width: var(--app-header-height);
    height: calc(var(--app-header-height) - 1px);
    box-sizing: border-box;
    align-items: center;
    justify-content: center;
    border-left: 1px solid var(--border-color);
    background: var(--pax-white);
  }

  .filter_trigger {
    position: relative;
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: 0;
    background: var(--pax-white);
    cursor: pointer;
  }

  .filter_trigger img {
    height: 1.3rem;
    width: 1.3rem;
    filter: brightness(0);
  }

  .filter_trigger:hover,
  .filter_trigger:focus,
  .filter_trigger:active { background: var(--pax-white); }
  .filter_status { position: absolute; top: 0.4rem; right: 0.45rem; display: flex; min-width: max-content; height: 1.3rem; align-items: center; justify-content: center; box-sizing: border-box; padding: 0.2rem 0.35rem; border: 0.1rem solid var(--pax-orange); border-radius: 1em; background: var(--pax-orange); color: var(--pax-white); font-size: 0.75rem; font-weight: 400; line-height: 1; white-space: nowrap; }

  .header_filter_content { display: flex; align-items: center; gap: 0; max-width: min(70vw, 70rem); }
  .active_filters { display: flex; width: fit-content; max-width: 30vw; min-width: 0; gap: 0.35rem; overflow: hidden; }
  .active_filter, .show_all_filters { flex: 0 0 auto; }
  .active_filter { display: flex; width: fit-content; height: var(--app-header-height); min-width: 0; max-width: none; box-sizing: border-box; align-items: center; gap: 1rem; padding: 0 0.6rem; border-left: 1px solid var(--border-color); background: var(--pax-white); color: var(--pax-black); font-size: 0.9rem; }
  .active_filter_text { display: flex; width: 10ch; min-width: 10ch; max-width: 10ch; flex: 0 0 10ch; flex-direction: column; padding: 0; border: 0; background: transparent; color: inherit; font: inherit; text-align: left; cursor: pointer; }
  .active_filter_type, .active_filter_attribute { display: block; width: 100%; max-width: 100%; height: auto; padding: 0; border-radius: 0; background: transparent; line-height: 1.2; }
  .active_filter_type { overflow: hidden; color: #555b63; font-size: inherit; text-overflow: ellipsis; white-space: nowrap; }
  .active_filter_attribute { overflow: hidden; font-size: inherit; font-weight: 700; text-overflow: ellipsis; white-space: nowrap; }
  .remove_active_filter { display: grid; width: 1.3rem; height: 1.3rem; flex: 0 0 auto; place-items: center; padding: 0; border: 0; border-radius: 50%; background: #e7e8ea; color: var(--pax-black); font-size: 1rem; line-height: 1; cursor: pointer; }
  .remove_active_filter:hover { background: #cfd1d4; }
  .show_all_filters { display: grid; width: var(--app-header-height); height: var(--app-header-height); place-items: center; padding: 0; border: 0; border-left: 1px solid var(--border-color); background: var(--pax-white); cursor: pointer; }
  .show_all_filters img { width: 1rem; height: 1rem; filter: brightness(0); }
  .show_all_filters:hover, .show_all_filters:focus, .show_all_filters:active { background: var(--pax-white); }


  @media (max-width: 70rem) {
    .active_filters { display: none; }
  }

  .filter_wrapper::before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: -0.3rem;
    width: 0.3rem;
    background: linear-gradient(to left, #d9d9d9, transparent);
  }

  .filter_container {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 0.5rem;
    min-height: 0;
    overflow-y: auto;
  }

  .filter_actions {
    display: flex;
    gap: 0.5rem;
  }

  .filter_action_row {
    width: 100%;
  }

  .filter_action_row :global(.mainbutton) {
    flex: 1 1 0;
    width: auto;
  }

  .filter {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
    width: 100%;
  }

  .filter span {
    display: block;
    flex-grow: 1;
    max-width: calc(100% - 3.5rem);
    height: 3rem;
    background-color: var(--pax-smoke);
    border-radius: 0.5rem;
    align-items: center;
    padding: 0 1rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: 3rem;
  }

  .filter.disable {
    pointer-events: auto;
    cursor: not-allowed !important;
  }

  .filter.disable span {
    pointer-events: auto;
    color: var(--pax-black-inactive);
    cursor: not-allowed;
  }

  .button_history_wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    margin: 1rem 0;
    box-sizing: border-box;
    justify-content: center;
  }
</style>
